import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const FeeHeads = lazy(() => import('../pages/fees/FeeHeads'));
const FeeStructure = lazy(() => import('../pages/fees/FeeStructure'));
const FeeCollection = lazy(() => import('../pages/fees/FeeCollection'));
const AllPayments = lazy(() => import('../pages/fees/AllPayments'));

const FeeRoutes = () => {
  return (
    <Routes>
      <Route path="heads" element={<FeeHeads />} />
      <Route path="structure" element={<FeeStructure />} />
      <Route path="collection" element={<FeeCollection />} />
      <Route path="payments" element={<AllPayments />} />
    </Routes>
  );
};

export default FeeRoutes;
